import { InvestigacionDTO } from "@DTOS";
import { DatosModalInvestigacionBasicos } from "@shared/components";

export abstract class InvestigacionesUtils {
    abstract crearInvestigacionAsync(): Promise<DatosModalInvestigacionBasicos>;
    abstract editarInvestigacionAsync(investigacion: InvestigacionDTO): Promise<DatosModalInvestigacionBasicos>;
}
